<template>
    <div class="color-palete">
        <ul v-bind:class="{ 'palete-ul':true, open: isOpen }">
            <li @click="grey" v-bind:class="{ 'grey':true, active: isActive == 'grey' }"><span></span></li>
            <li @click="orange" v-bind:class="{ 'orange':true, active: isActive == 'orange' }"><span></span></li>
            <li @click="cherry" v-bind:class="{ 'cherry':true, active: isActive == 'cherry' }"><span></span></li>
            <li @click="green" v-bind:class="{ 'green':true, active: isActive == 'green' }"><span></span></li>
            <li @click="blue" v-bind:class="{ 'blue':true, active: isActive == 'blue' }"><span></span></li>
        </ul>
        <button @click="isOpen = !isOpen" class="thm-btn"><i class="icon-theme"></i><span>{{$t('Themes')}}</span></button>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isOpen: false, 
                isActive: this.$store.state.config.user.theme_code ? this.$store.state.config.user.theme_code : 'grey',
            };
        },
        mounted() {
            let themeName = this.isActive;
            this[this.isActive](false);
        },
        methods: {
            grey(canSave = true) {
                if (!canSave || this.$route.name != "Dashboard") {
                    let bodyStyles = document.body.style;
                    bodyStyles.setProperty("--base-theme-color", "#7f7f7d");
                    bodyStyles.setProperty("--table-theme-light-color", "#cececd");
                    bodyStyles.setProperty("--table-row-hover-color", "#f1f1f1");
                    bodyStyles.setProperty("--icon-verticle-line-color", "#545454");
                }
                this.isActive = 'grey';
                this.$store.state.config.user.theme_code = this.isActive;
                this.saveTheme(canSave);
            },
            orange(canSave = true) {
                if (!canSave || this.$route.name != "Dashboard") {
                    let bodyStyles = document.body.style;
                    bodyStyles.setProperty("--base-theme-color", "#f7a959");
                    bodyStyles.setProperty("--table-theme-light-color", "#fddbb8");
                    bodyStyles.setProperty("--table-row-hover-color", "#fff4e9");
                    bodyStyles.setProperty("--icon-verticle-line-color", "#dc7f1f");
                }
                this.isActive = 'orange';
                this.$store.state.config.user.theme_code = this.isActive;
                this.saveTheme(canSave);
            },
            cherry(canSave = true) {
                if (!canSave || this.$route.name != "Dashboard") {
                    let bodyStyles = document.body.style;
                    bodyStyles.setProperty("--base-theme-color", "#f16060");
                    bodyStyles.setProperty("--table-theme-light-color", "#ffc9c9");
                    bodyStyles.setProperty("--table-row-hover-color", "#ffeeee");
                    bodyStyles.setProperty("--icon-verticle-line-color", "#ca3e3e");
                }
                this.isActive = 'cherry';
                this.$store.state.config.user.theme_code = this.isActive;
                this.saveTheme(canSave);
            },
            green(canSave = true) {
                if (!canSave || this.$route.name != "Dashboard") {
                    let bodyStyles = document.body.style;
                    bodyStyles.setProperty("--base-theme-color", "#0c8840");
                    bodyStyles.setProperty("--table-theme-light-color", "#a0e4bd");
                    bodyStyles.setProperty("--table-row-hover-color", "#f0fff7");
                    bodyStyles.setProperty("--icon-verticle-line-color", "#05692f");
                }
                this.isActive = 'green';
                this.$store.state.config.user.theme_code = this.isActive;
                this.saveTheme(canSave);
            },
            blue(canSave = true) {
                if (!canSave || this.$route.name != "Dashboard") {
                    let bodyStyles = document.body.style;
                    bodyStyles.setProperty("--base-theme-color", "#2980b9");
                    bodyStyles.setProperty("--table-theme-light-color", "#cce9fd");
                    bodyStyles.setProperty("--table-row-hover-color", "#ebf7ff");
                    bodyStyles.setProperty("--icon-verticle-line-color", "#025a94");
                }
                this.isActive = 'blue';
                this.$store.state.config.user.theme_code = this.isActive;
                this.saveTheme(canSave);
            },
            saveTheme(canSave) {
                if (canSave) {
                    request({
                        url: "user/profile-update",
                        method: "POST",
                        data: {
                            theme_code: this.isActive
                        }
                    }).then(response => {
                        this.$store.dispatch("setConfig", {
                            user: response.data.data
                        });
                        if (this.$route.name == "Dashboard") {
                            window.location.reload();
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                }
            }
        }
    };

</script>

<style lang="scss">
    .thm-btn {
        background-color: var(--theme-btn-background);
        border-radius: 50px;
        padding: 4px 20px;
        font-size: 100%;
        color: var(--base-text-color);
        font-weight: 600;
        text-transform: capitalize;
        border: 0;
        margin: 12px 0;
        cursor: pointer;
        outline: 0;
        z-index: 1;
        width: 100%;

        i {
            padding-right: 4px;
            color: var(--base-theme-color);
            font-size: 125%;
            line-height: 10px;
            vertical-align: middle;
        }
    }

    .palete-ul {
        display: block;
        font-size: 0;
        vertical-align: middle;
        transition: all 0.6s ease;
        right: 150px;
        position: absolute;
        z-index: 0;
        bottom: 16px;
        width: 140px;
        opacity: 0;

        &.open {
            font-size: 0;
            vertical-align: middle;
            transition: all 0.6s ease;
            opacity: 1;
        }

        li {
            display: inline;
            padding: 0 4px;
            cursor: pointer;

            span {
                width: 20px;
                height: 20px;
                border-radius: 100%;
                display: inline-block;
                transition: all 0.3s ease;

                &:hover {
                    border: 4px solid var(--base-text-color);
                }
            }

            &.active {
                span {
                    border: 4px solid var(--base-text-color);
                }
            }

            &.grey {
                span {
                    background-color: #7f7f7d;
                }
            }

            &.orange {
                span {
                    background-color: #f7a959;
                }
            }

            &.cherry {
                span {
                    background-color: #f16060;
                }
            }

            &.green {
                span {
                    background-color: #27ae60;
                }
            }

            &.blue {
                span {
                    background-color: #2980b9;
                }
            }
        }
    }

    @media only screen and (max-width: 568px) {
        .palete-ul {
            right: 120px;

            li {
                padding: 0 3px;

                span {
                    width: 14px;
                    height: 14px;
                }

                &.active {
                    span {
                        border: 2px solid var(--base-text-color);
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 480px) {
        .thm-btn {
            padding: 4px 10px;
        }

        .palete-ul {
            right: 80px;
        }
    }

    @media only screen and (max-width: 414px) {
        .thm-btn {
            span {
                display: none;
            }
        }

        .color-palete {
            width: 15%;
        }

        .palete-ul {
            right: -20px;
            bottom: 55px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Layout/Widgets/color-themes/color-themes.vue